import script from "./BaseButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseButton.vue?vue&type=script&setup=true&lang=ts"

import "./BaseButton.vue?vue&type=style&index=0&id=4a7242cc&lang=scss"

const __exports__ = script;

export default __exports__